export const EnumTaskStatus = Object.freeze({
  NEW: 'NEW',
  PROCESSING: 'PROCESSING',
  FINISH: 'FINISH',
  NOT_COMPLETED: 'NOT_COMPLETED',
  CANCELED: 'CANCELED',
})

export const EnumQuestionType = Object.freeze({
  YES_NO_QUESTION: 'YES_NO_QUESTION',
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  QUIZ: 'QUIZ',
  SHORT_ANSWER: 'SHORT_ANSWER',
  CONDITIONAL_MULTIPLE_CHOICE: 'CONDITIONAL_MULTIPLE_CHOICE',
})

export const TaskStatus = [
  { id: EnumTaskStatus.NEW, text: 'Mới tạo' },
  { id: EnumTaskStatus.PROCESSING, text: 'Đang xử lý' },
  { id: EnumTaskStatus.FINISH, text: 'Hoàn thành' },
  { id: EnumTaskStatus.NOT_COMPLETED, text: 'Không hoàn thành' },
  { id: EnumTaskStatus.CANCELED, text: 'Đã hủy' },
]

export const optionColorStatus = {
  [EnumTaskStatus.NEW]: 'primary',
  [EnumTaskStatus.PROCESSING]: 'warning',
  [EnumTaskStatus.FINISH]: 'success',
  [EnumTaskStatus.NOT_COMPLETED]: 'secondary',
  [EnumTaskStatus.CANCELED]: 'danger',
}

export const EnumTaskResultStatus = Object.freeze({
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  OTHERS: 'OTHERS',
})

export const TaskResultStatus = [
  { id: EnumTaskResultStatus.SUCCESS, text: 'Thành công' },
  { id: EnumTaskResultStatus.FAILED, text: 'Thất bại' },
  { id: EnumTaskResultStatus.OTHERS, text: 'Khác' },
]

export const mapResultName = TaskResultStatus.reduce((map, item) => {
  map[item.id] = item.text
  return map
}, {})

export const EnumTaskApplyFor = Object.freeze({
  MO: 'MO',
  MA: 'MA',
  STORE: 'STORE',
})

export const TaskApplyFor = [
  // { id: EnumTaskApplyFor.MO, text: "Merchant owner" },
  { id: EnumTaskApplyFor.MA, text: 'Merchant account' },
  { id: EnumTaskApplyFor.STORE, text: 'Cửa hàng' },
]

export const FlowChangeStatus = {
  [EnumTaskStatus.NEW]: [EnumTaskStatus.PROCESSING, EnumTaskStatus.FINISH, EnumTaskStatus.CANCELED],
  [EnumTaskStatus.PROCESSING]: [EnumTaskStatus.FINISH, EnumTaskStatus.CANCELED],
  [EnumTaskStatus.FINISH]: [],
  [EnumTaskStatus.CANCELED]: [],
}

export const EnumTaskMethodCare = Object.freeze({
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
})

export const TaskMethodCare = [
  { id: EnumTaskMethodCare.ONLINE, text: 'Online' },
  { id: EnumTaskMethodCare.OFFLINE, text: 'Offline' },
]

export const MaRole = [
  { id: 'SALE_DIRECTOR', text: 'Giám đốc kinh doanh' },
  { id: 'MARKETING', text: 'Marketing' },
  { id: 'REGION_DIRECTOR', text: 'Giám đốc vùng' },
  { id: 'SALE_ADMIN', text: 'Sales admin' },
  { id: 'SALE_MANAGER', text: 'Sales manager' },
  { id: 'SALE_LEADER', text: 'Sales leader' },
  { id: 'AFTER_SALE_LEADER', text: 'After sale leader' },
  { id: 'TELESALE_LEADER', text: 'Telesale leader' },
  { id: 'TRAINER_LEADER', text: 'Quản lý đào tạo' },
  { id: 'SALE', text: 'Sales' },
  { id: 'ACCOUNT_MANAGER', text: 'Account manager' },
  { id: 'AFTER_SALE', text: 'After sale' },
  { id: 'TELESALE', text: 'Telesale' },
  { id: 'TRAINER', text: 'Nhân viên đào tạo' },
  { id: 'KEY_ACCOUNT', text: 'Key account' },
  { id: 'OPERATOR_SYSTEM', text: 'Operator system' },
  { id: 'COOPERATOR', text: 'CTV Kinh Doanh' },
  { id: 'AFTER_SALE_OFFLINE', text: 'After sale offline' },
  { id: 'SUPER_ADMIN', text: 'SUPER ADMIN' },
]

export const StoreState = [
  { id: 'NEW', text: 'Mới', bgColor: 'badge-success', class: 'text-success' },
  { id: 'OLD', text: 'Cũ', bgColor: 'badge-danger', class: 'text-danger' },
]

export const EnumTransformStatus = Object.freeze({
  NEW: 'NEW',
  NOTICE_MC: 'NOTICE_MC',
  MC_CONFIRMED: 'MC_CONFIRMED',
  MC_ACTIVATED: 'MC_ACTIVATED',
  MC_SIGNED_NL_CONTRACT: 'MC_SIGNED_NL_CONTRACT',
  MC_REJECTED: 'MC_REJECTED',
  MC_REJECTED_SIGNED_VM_LIQUIDATION: 'MC_REJECTED_SIGNED_VM_LIQUIDATION',
  ADDITIONAL_TID: 'ADDITIONAL_TID',
  ADDITIONAL_MID: 'ADDITIONAL_MID',
  MC_SIGNED_NL_CONTRACT_NOT_ACTIVE: 'MC_SIGNED_NL_CONTRACT_NOT_ACTIVE',
  MC_SIGNED_NL_SIGNED: 'MC_SIGNED_NL_SIGNED',
})

export const TRANSFORM_STATUS_OPTIONS = [
  // { id: EnumTransformStatus.NEW, text: 'Mới tạo' },
  { id: EnumTransformStatus.NOTICE_MC, text: 'Đã gửi thông báo cho MC' },
  { id: EnumTransformStatus.MC_CONFIRMED, text: 'Mc đã xác nhận' },
  { id: EnumTransformStatus.MC_ACTIVATED, text: 'Mc đã được kích hoạt' },
  { id: EnumTransformStatus.MC_SIGNED_NL_CONTRACT, text: 'Đã ký HĐ Ngân Lượng' },
  { id: EnumTransformStatus.MC_REJECTED, text: 'MC không đồng ý' },
  {
    id: EnumTransformStatus.MC_REJECTED_SIGNED_VM_LIQUIDATION,
    text: 'Mc Từ chối - Đã thanh lý Vi Mô ',
  },
  { id: EnumTransformStatus.ADDITIONAL_TID, text: 'Đã đăng ký thêm TID' },
  { id: EnumTransformStatus.ADDITIONAL_MID, text: 'Đã đăng ký thêm MID' },
  {
    id: EnumTransformStatus.MC_SIGNED_NL_CONTRACT_NOT_ACTIVE,
    text: 'MC đã ký hợp đồng NL, chờ kích hoạt',
  },
  {
    id: EnumTransformStatus.MC_SIGNED_NL_SIGNED,
    text: 'MC và NL đã ký',
  },
]
